import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  allEmployeeTags: [],
};

const employeeTagModule = {
  state,
  mutations,
  actions,
  getters,
};

export default employeeTagModule;
